module.exports = __webpack_public_path__ + "static/media/ActivePrevButton.60ed64a6.svg";